import { useProfiles } from '~/modules/user-profiles/hooks';

/**
 * What the main menu says under Singers - the one glanceable line about the room that replaced
 * three buttons whose labels all looked alike.
 *
 * Profiles, not singers: a round is recorded against whatever name a player carries, so the device
 * has sung with plenty of people a profile was never made for. The count is of the ones it can name
 * again, which is the thing the screen behind this button is for. Reads "none yet" for a device
 * with no profiles, matching `use-mic-setup-summary` - the two sit in the same slot, and a room
 * that has set nothing up should hear the same phrase from both.
 */
export default function useSingersSummary() {
  const profiles = useProfiles();

  if (profiles.length === 0) return 'none yet';

  return `${profiles.length} ${profiles.length === 1 ? 'profile' : 'profiles'}`;
}
